import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExternalNavigationService {
  public navigateTo(url: string): void {
    window.location.href = url;
  }
}
